import { render, staticRenderFns } from "./VuesticColorPickerInput.vue?vue&type=template&id=edbf566a"
import script from "./VuesticColorPickerInput.vue?vue&type=script&lang=js"
export * from "./VuesticColorPickerInput.vue?vue&type=script&lang=js"
import style0 from "./VuesticColorPickerInput.vue?vue&type=style&index=0&id=edbf566a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports